






































import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import defineAbilityFor from "@/services/ability";
import router from "@/router";
import { GroupDTO, ROLES } from "@/model/user";
import { AuthService } from "@/common/api/services/AuthService";
import { AuthLoginRequest } from "@/common/api/index";
import { AppVersion } from "@/common/utils";

const auth = namespace("Auth");

@Component({
  name: "LoginPage",
  directives: {},
})
export default class LoginPage extends Vue {
  private user: AuthLoginRequest = {
    email: "",
    password: "",
  };
  private errorMessage = "";
  public appVersion = AppVersion();

  @auth.Getter
  userLogging: any;
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  updateExpiredAt!: (time: string) => void;
  @auth.Action
  updateRole!: (role: string) => void;
  @auth.Action
  setUser!: (user) => void;
  @auth.Action
  fetchCurrentUser!: () => void;
  @auth.Action
  updateUsingGroup!: (id: string) => void;
  @auth.Action
  updateGroupUsers!: (groups: GroupDTO) => void;

  private async submit() {
    let response: any;
    try {
      response = await AuthService.authLogin(this.user);
    } catch (error: any) {
      response = error.body;
    }

    if (response.status == "error") {
      this.errorMessage = response.message;
      return;
    }

    const user = response.data.user;

    // Save it to state
    this.updateToken(response.data.token);
    await this.fetchCurrentUser();

    // Set ability
    this.$ability.update(defineAbilityFor(user.role).rules);

    return router.push({ name: "admin.news" });
  }
}
